import { render } from "./HelloWorld.vue?vue&type=template&id=142edf4c&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=142edf4c&scoped=true&lang=scss"

import exportComponent from "/var/www/server_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142edf4c"]])

export default __exports__